import axios from "axios";

/**
 * O bundle do painel (este ficheiro) não usa o `window.axios` do bootstrap.js.
 * Sem `withCredentials`, pedidos do HTML em pipeline.*.eloca.com.br para o app Laravel
 * não enviam o cookie de sessão e rotas como campanha-internas/popup respondem 401.
 */
axios.defaults.withCredentials = true;

import Vue from "vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import Vuetify from "vuetify";

import VueExcelXlsx from "vue-excel-xlsx";

import $ from "jquery";
window.$ = $;
window.jQuery = $;

import EmailConversa from "./components/vue/email/EmailConversa.vue";
import ModalResposta from "./components/vue/email/ModalResposta.vue";
import ConfigElocaErp from "./components/vue/config-eloca-erp/ConfigElocaErp.vue";
import RelatorioProdutividade from "./components/vue/Reletorios/RelatorioProdutividade.vue";
import RelatorioEngajamentoTemplates from "./components/vue/Reletorios/RelatorioEngajamentoTemplates.vue";
import RelatorioFaturasIugu from "./components/vue/Reletorios/RelatorioFaturasIugu.vue";
import BotNotificacoes from "./components/vue/Reletorios/BotNotificacoes.vue";
import VuetifyWrapper from "./components/vue/VuetifyWrapper.vue";
import TreinamentoIA from "./components/vue/ia/TreinamentoIA.vue";
import PlaygroundIA from "./components/vue/ia/PlaygroundIA.vue";
import RelatoriosIA from "./components/vue/ia/RelatoriosIA.vue";
import RelatoriosIAConsumo from "./components/vue/ia/RelatoriosIAConsumo.vue";
import SimpleChart from "./components/vue/ui/SimpleChart.vue";
import CampanhaInternaAudienciasApp from "./components/vue/campanha-interna-audiencias/CampanhaInternaAudienciasApp.vue";
import CampanhaInternaCampanhasApp from "./components/vue/campanha-interna-campanhas/CampanhaInternaCampanhasApp.vue";
import CampanhaInternaPopupHost from "./components/vue/campanha-interna-campanhas/CampanhaInternaPopupHost.vue";
import CarteiraCadastroGruposApp from "./components/vue/carteira/cadastros/CarteiraCadastroGruposApp.vue";
import CarteiraCadastroCargosApp from "./components/vue/carteira/cadastros/CarteiraCadastroCargosApp.vue";
import CarteiraCadastroDepartamentosApp from "./components/vue/carteira/cadastros/CarteiraCadastroDepartamentosApp.vue";
import CarteiraCadastroCamposPersonalizadosApp from "./components/vue/carteira/cadastros/CarteiraCadastroCamposPersonalizadosApp.vue";
import CarteiraKanbanApp from "./components/vue/carteira/CarteiraKanbanApp.vue";
import CarteiraDashboardApp from "./components/vue/carteira/CarteiraDashboardApp.vue";
import ClienteFilhosModal from "./components/vue/carteira/ClienteFilhosModal.vue";
import ModalCamposEquipamentoOportunidade from "./components/vue/oportunidades/ModalCamposEquipamentoOportunidade.vue";
import ModalCamposAlternativosItemOportunidade from "./components/vue/oportunidades/ModalCamposAlternativosItemOportunidade.vue";
import ModalCamposPersonalizadosItemOportunidade from "./components/vue/oportunidades/ModalCamposPersonalizadosItemOportunidade.vue";
import ProdutosCamposPersonalizadosCadastroApp from "./components/vue/produtos/ProdutosCamposPersonalizadosCadastroApp.vue";

Vue.config.productionTip = false;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("email-conversa", EmailConversa);
Vue.component("email-resposta", ModalResposta);
Vue.component("config-eloca-erp", ConfigElocaErp);
Vue.component("relatorio-produtividade", RelatorioProdutividade);
Vue.component("relatorio-engajamento-templates", RelatorioEngajamentoTemplates);
Vue.component("relatorio-faturas-iugu", RelatorioFaturasIugu);
Vue.component("bot-notificacoes", BotNotificacoes);
Vue.component("vuetify-wrapper", VuetifyWrapper);
Vue.component("treinamento-ia", TreinamentoIA);
Vue.component("playground-ia", PlaygroundIA);
Vue.component("relatorios-ia", RelatoriosIA);
Vue.component("relatorios-ia-consumo", RelatoriosIAConsumo);
Vue.component("simple-chart", SimpleChart);
Vue.component("campanha-interna-audiencias-app", CampanhaInternaAudienciasApp);
Vue.component("campanha-interna-campanhas-app", CampanhaInternaCampanhasApp);
Vue.component("campanha-interna-popup-host", CampanhaInternaPopupHost);
Vue.component("carteira-cadastro-grupos-app", CarteiraCadastroGruposApp);
Vue.component("carteira-cadastro-cargos-app", CarteiraCadastroCargosApp);
Vue.component("carteira-cadastro-departamentos-app", CarteiraCadastroDepartamentosApp);
Vue.component("carteira-cadastro-campos-personalizados-app", CarteiraCadastroCamposPersonalizadosApp);
Vue.component("carteira-kanban-app", CarteiraKanbanApp);
Vue.component("carteira-dashboard-app", CarteiraDashboardApp);
Vue.component("cliente-filhos-modal", ClienteFilhosModal);
Vue.component("modal-campos-equipamento-oportunidade", ModalCamposEquipamentoOportunidade);
Vue.component("modal-campos-alternativos-item-oportunidade", ModalCamposAlternativosItemOportunidade);
Vue.component("modal-campos-personalizados-item-oportunidade", ModalCamposPersonalizadosItemOportunidade);
Vue.component(
    "produtos-campos-personalizados-cadastro-app",
    ProdutosCamposPersonalizadosCadastroApp
);

Vue.use(CKEditor);
Vue.use(Vuetify);
Vue.use(VueExcelXlsx);

const app = new Vue({
    delimiters: ["[[", "]]"],
    vuetify: new Vuetify(),
}).$mount("#app");
